var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"page layout-padding bg-white column no-wrap"},[(!_vm.$q.platform.is.mobile)?_c('SmartSearchResultsDesktop'):_c('SmartSearchResultsMobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }